const statusTitleMap = {
    1: "Autorizada",
    2: "Concluída",
    3: "Rejeitada",
    4: "Cancelada",
    5: "Em processamento",
    6: "Pendente",
    7: "Falha",
};

const statusTypeMap = {
    1: "success",
    2: "success",
    3: "danger",
    4: "danger",
    5: "info",
    6: "warning",
    7: "danger",
};

export function getNfseStatusTitle(status) {
    return statusTitleMap[status];
}

export function getNfseStatusType(status) {
    return statusTypeMap[status];
}